import { useAppSelector, useIsDesktop } from 'Hooks';
import { CustomMetaTitle, LinkReturnToMain } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useCallback, useEffect, useState } from 'react';
import { getIsApproved } from 'API/compassRights';
import { AgreementModal } from './AgreementModal';
import { CompassRightsContextWrapper } from './CompassRightsContextWrapper';
import { EntitlementsContextProvider } from 'Context/CompassRightsContext/EntitlementsProvider';
import { Avatar, Stack } from '@mui/material';
import { CompassRightsMobileBackground } from 'Images';

export const CompassRights = () => {
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const [modalAgreementBox, setModalAgreementBox] = useState<boolean>(true);
  const initCompassRights = useCallback(async () => {
    window.scroll(0, 0);
    const isApproved = await getIsApproved();
    setModalAgreementBox(isApproved);
  }, []);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    initCompassRights();
  }, [initCompassRights, imposterId]);

  return (
    <Stack
      gap={isDesktop ? '32px' : '24px'}
      maxWidth={isDesktop ? '1029px' : 'initial'}
    >
      {!modalAgreementBox && (
        <AgreementModal setModalAgreementBox={setModalAgreementBox} />
      )}
      <CustomMetaTitle title={Dictionary[DICTIONARY.CompassRights].title} />
      <LinkReturnToMain />
      <EntitlementsContextProvider>
        {modalAgreementBox && <CompassRightsContextWrapper />}
      </EntitlementsContextProvider>
      {!isDesktop && (
        <Avatar
          src={CompassRightsMobileBackground}
          alt={''}
          sx={{
            width: 'auto',
            height: 'auto',
            position: 'absolute',
            top: '135px',
            left: 0,
            right: 0,
            zIndex: -2,
          }}
        />
      )}
    </Stack>
  );
};
